import React from 'react';
import { X } from 'lucide-react';
import PricingCard from './PricingCard';

const PricingModal = ({ isOpen, onClose, category, pricingData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative bg-white rounded-lg shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-2xl font-bold text-slate-900">{category} - Pricing Packages</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <X className="h-6 w-6 text-slate-600" />
          </button>
        </div>
        
        {/* Pricing Cards */}
        <div className="p-6">
          <p className="text-slate-600 mb-6">
            Choose the package that best fits your needs. All packages include expert support and guidance throughout the process.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {pricingData.map((pkg, index) => (
              <PricingCard key={index} {...pkg} />
            ))}
          </div>
        </div>
        
        {/* Footer */}
        <div className="bg-slate-50 px-6 py-4 border-t border-slate-200">
          <p className="text-sm text-slate-600 text-center">
            Have questions? <a href="/contact" className="text-blue-600 hover:text-blue-700 font-semibold">Contact our team</a> for personalized assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingModal;
